export function includePixel(pixelSrc: string) {
  const pixelTag = document.createElement('img') as any;
  pixelTag.src = pixelSrc;
  pixelTag.height = '1';
  pixelTag.width = '1';
  document.body.appendChild(pixelTag);
}
